import { useEffect } from 'react';
import { CookiesProvider } from 'react-cookie';
import { ToastContainer } from 'react-toastify';
import ScrollToTop from './components/common/ScrollToTop';
import DefinitionModalContainer from './components/DefinationModalContainer';
import { NetworkStatusToast } from './components/network/NetworkStatusToast';
import { AlertProvider } from './contexts/AlertContext';
import { AuthProvider } from './contexts/AuthContext';
import { DefinitionModalProvider } from './contexts/DefinitionModalContext';
import { LinkInterceptorProvider } from './contexts/LinkInterceptorContext';
import { useXssInputProtection } from './hooks/useXssInputProtection';
import { initAnalytics } from './util/posthog';
import AppRoutes from './routes';
// eslint-disable-next-line import/no-unresolved
import 'shepherd.js/dist/css/shepherd.css';

function App() {
  useXssInputProtection();

  useEffect(() => {
    void initAnalytics();
  }, []);

  return (
    <CookiesProvider>
      <LinkInterceptorProvider>
        <AuthProvider>
          <AlertProvider>
            <DefinitionModalProvider>
              <AppRoutes />
              <ScrollToTop />
              <DefinitionModalContainer />
              <NetworkStatusToast />
              <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
            </DefinitionModalProvider>
          </AlertProvider>
        </AuthProvider>
      </LinkInterceptorProvider>
    </CookiesProvider>
  );
}

export default App;
